// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"147":"5ee4864d","374":"d5a9ad7f","381":"32e50bce","525":"ff893c63","780":"82d21ce4","781":"83fd8bf7","783":"31306c8f","827":"645fe4a4","894":"e504aa56"}[chunkId] + ".js";
};